export default __webpack_public_path__ + "static/media/illustration-health-3-w@3x.2473944e.webp";